module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/_modalpopup/summarydetail-popup/summarydetail-popup.component.css
// module id = ./src/app/sendMoney/_modalpopup/summarydetail-popup/summarydetail-popup.component.css
// module chunks = main